export default __webpack_public_path__ + "static/photo2-808df91048f1739e4bcca27933660789.jpg";